import { useTranslation } from 'react-i18next';
import { DataTable } from '@/components/data-table/data-table';
import { DataTableActionBar } from '@/components/data-table/data-table-action-bar';
import { DataTableFilterMenu } from '@/components/data-table/data-table-filter-menu';
import { DataTableSortList } from '@/components/data-table/data-table-sort-list';
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options';
import { Button } from '@/components/ui/button';
import { usePurchasePlanningTable } from '@/features/purchase-planning/hooks/use-purchase-planning-table';
import { cn } from '@/lib/utils';

export function PurchasePlanningTable() {
  const { t, i18n } = useTranslation();

  const { table, isPending, lastVersion } = usePurchasePlanningTable();

  return (
    <div
      className={cn(
        'relative flex min-h-0 flex-1 flex-col',
        isPending && 'pointer-events-none',
      )}
    >
      {isPending && (
        <div className='absolute inset-0 z-20 animate-pulse rounded-md bg-muted/40' />
      )}
      <DataTable
        actionBar={
          <DataTableActionBar table={table}>
            <Button variant='outline'>{t('add', { ns: 'common' })}</Button>
          </DataTableActionBar>
        }
        className={cn('min-h-0', isPending && 'opacity-60')}
        table={table}
      >
        <div
          className='flex w-full flex-wrap items-start justify-between gap-2 p-1'
          role='toolbar'
        >
          <div className='flex flex-1 flex-wrap items-center gap-2'>
            <DataTableFilterMenu table={table} />
            <DataTableSortList table={table} />
          </div>
          <div className='flex items-center gap-2'>
            {lastVersion && (
              <div className='mr-2 flex gap-1'>
                <span className='text-muted-foreground text-sm italic'>
                  {t('last version', { ns: 'purchasePlanning' })}
                </span>
                <span className='font-medium text-muted-foreground text-sm italic'>
                  {new Date(lastVersion).toLocaleDateString(i18n.language, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </span>
              </div>
            )}
            <DataTableViewOptions align='end' table={table} />
          </div>
        </div>
      </DataTable>
    </div>
  );
}
